import ISceneGeometry from "../sceneObject/ISceneGeometry";
import SceneGeometry from "../sceneObject/SceneGeometry";
import { SceneObjectStyle } from "../sceneObject/SceneObjectStyle";
import SceneObjectData from "../sceneObjectData/SceneObjectData";

export default abstract class CompoundSceneGeometry<T> extends SceneGeometry<T> {
    
    constructor() {
        super();
    }

    protected abstract getSubGeometries() : ISceneGeometry[];

    setStyle(style: SceneObjectStyle): void {
        if (this.style === style) return;
        this.getSubGeometries().forEach(subGeom => subGeom.setStyle(style));
        this.style = style;
    }

    protected updateGeometry(data:SceneObjectData, forceUpdate: boolean): boolean {
        let result = true;
        this.getSubGeometries().forEach( subGeom => {
            result == subGeom.update(data, forceUpdate) && result;
            subGeom.setStyle(this.style);
        });

        return result;
    }
};